module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.90c0409f.ttf";